import Vue from 'vue'
import Vuex from 'vuex'

import { Loading,  QSpinnerFacebook,  } from 'quasar'
import { Notify } from 'quasar'

Vue.use(Vuex)

// var URL = 'http://localhost:5050/'
var URL = 'https://serverpelapooro.konaweselatankab.go.id/'
// var URL = 'http://10.91.178.2:5079/'

export default new Vuex.Store({
  state: {
    
    btn : {
      add : false,
      edit : false,
      remove : false,
    },
    url : {
      URL_APP : URL,

      URL_DM_REGISTER : URL+'api/v1/dm_registrasi/',
      URL_DM_MENU : URL+'api/v1/dm_menuList/',
      URL_DM_KLP_USERS : URL+'api/v1/dm_kelompokUsers/',
      URL_DM_KATEGORI_PENOLAKAN : URL+'api/v1/dm_kategoriPenolakan/',
      URL_DM_OPD_TERLAPOR : URL+'api/v1/dm_opdTerlapor/',
      URL_DM_USER_MASYARAKAT : URL+'api/v1/dm_userMasyarakat/',
      URL_PENGADUAN : URL+'api/v1/pengaduan/',
      URL_TELAAH : URL+'api/v1/telaah/',
      URL_TINDAKLANJUT : URL+'api/v1/tindaklanjut/',
      URL_FEEDBACK : URL+'api/v1/feedback/',
      URL_REGISTRASI : URL+'api/v1/registrasi/',
      //====//
      URL_DASHBOARD : URL+'api/v1/dashboard/',
      checkAuth : URL + 'api/v1/checkAuth/',
    },

    list_menu : null,
    aksesMenu : {},
    list_triwulan: [],
    list_jns_penerimaan: [],
    list_kelas_penerima: [],
    list_tahun: [
      { id: 2017, tahun: '2017'},
      { id: 2018, tahun: '2018'},
      { id: 2019, tahun: '2019'},
      { id: 2020, tahun: '2020'},
      { id: 2021, tahun: '2021'},
      { id: 2022, tahun: '2022'},
      { id: 2023, tahun: '2023'},
      { id: 2024, tahun: '2024'},
    ],
    list_status: [
      { id: 0, uraian: 'Diproses'},
      { id: 1, uraian: 'Diterima'},
      { id: 3, uraian: 'Ditolak'},
    ],

    list_tindaklanjut: [
      { id: 2, uraian: 'Selesai Tindak Lanjut'},
      { id: 1, uraian: 'Proses Tindak Lanjut'},
    ],

    page_first: 1,
    page_last: 0,
    cari_value: "",
    cek_load_data : true,

    type : [
      {id : 0, uraian : 'Single Menu'},
      {id : 1, uraian : 'Multy Menu'}
    ],

    
  },
  mutations: {
    listJeniskategorilokasi(state){

      fetch(state.url.URL_MasterKategoriLokasi, {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        }
      })
        .then(res => res.json())
        .then(res_data => {
          state.list_MasterKategoriLokasi = res_data;
      });

    },

    listApelJenis(state){

      fetch(state.url.URL_apelJenis, {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        }
      })
        .then(res => res.json())
        .then(res_data => {
          // console.log(res_data)
          state.list_ApleJenis = res_data;
      });

    },

    getStorage(state){
      var get_profile = JSON.parse(localStorage.profile);
      state.unit_kerja = get_profile.profile.unit_kerja; 
    },
    shoWLoading(){
      const spinner = typeof QSpinnerFacebook !== 'undefined'
        ? QSpinnerFacebook // Non-UMD, imported above
        : Quasar.components.QSpinnerFacebook // eslint-disable-line


      Loading.show({
        spinner,
        spinnerColor: 'yellow',
        spinnerSize: 140,
        backgroundColor: 'purple',
        // message: 'Loading... Tunggu beberapa saat, system sedang menyesuaikan akun anda..!',
        // messageColor: 'white'
      })
    },
    hideLoading(){
      Loading.hide()
    },
    shoWNotify(state, message, color, icon){
      Notify.create({
        message: message,
        color: color,
        position : 'top-right',
        icon:icon
      })
    },
  },
  actions: {
  },
  modules: {
  }
})
